import { useContext, useState, useEffect } from 'react';
import { AuthContext } from '@CONTEXTS';

const useMerchantList = () => {
  const { info } = useContext(AuthContext);
  let temp = null;
  if (info.merchantList) {
    temp = [{ value: null, label: info.companyName }];
    info.merchantList.forEach((item) => {
      temp.push({
        value: item.merchantCompanyId,
        label: `${item.merchantName}-${item.abbreviationCode}`,
      });
    });
  }

  return temp;
};

export default useMerchantList;
